import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './CardHoverPreview.css';

// The big "preview on the side" pane shown when hovering a card image while shopping.
// Extracted from Card.js so the broker portal can reuse the exact same preview.
export const CardPreviewPane = ({ src, alt, mousePos }) =>
    createPortal(
        <div
            className="card-preview-pane"
            style={{
                position: 'fixed',
                pointerEvents: 'none', // purely visual — never intercept clicks
                left: mousePos.x < window.innerWidth / 2 ? 'auto' : '20px',
                right: mousePos.x < window.innerWidth / 2 ? '20px' : 'auto',
                top: '80px',
                bottom: '20px',
                backgroundColor: 'white',
                zIndex: 9998,
                padding: '20px',
                borderRadius: '15px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <img
                src={src}
                alt={alt}
                style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    borderRadius: '10px',
                }}
            />
        </div>,
        document.body
    );

// A thumbnail <img> that shows the big side-preview pane on hover (desktop only),
// matching the shopping-site behavior. Used by the broker cert/listing tables.
export const ImageWithHoverPreview = ({ src, alt, className }) => {
    const [hovered, setHovered] = useState(false);
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

    return (
        <>
            <img
                src={src}
                alt={alt}
                className={className}
                onMouseEnter={() => { if (!isMobile) setHovered(true); }}
                onMouseLeave={() => setHovered(false)}
                onMouseMove={(e) => { if (!isMobile) setMousePos({ x: e.clientX, y: e.clientY }); }}
            />
            {hovered && !isMobile && <CardPreviewPane src={src} alt={alt} mousePos={mousePos} />}
        </>
    );
};
